// extracted by mini-css-extract-plugin
export default {"categoryContainer":"CategoryContainer_categoryContainer__8L224"};